(() => {
  if (customElements.get('t2m-sim-enrollment')) return;
  const serviceIds=[67868285796666,67868285829434,67868285862202];
  const planId=694433415482;
  const packUnits={53704230797626:2,53278119330106:2,53704230830394:4,53278119362874:4,53704230863162:6,53278119395642:6,53704230895930:8,53278119428410:8,53704230928698:10};
  const route=path=>(window.Shopify?.routes?.root||'/')+path;
  let messages={};
  let pending=false;
  let checkoutReady=false;
  const serviceFor=parent=>{
    const service=String(Object.entries(parent.properties||{}).find(([name])=>name.trim().toLowerCase()==='service')?.[1]||'').trim().toLowerCase();
    if (/\b(?:multi.?year|[2-9]\s*[- ]?\s*(?:year|yr)|lifetime)\b/.test(service)) return null;
    if (/^(global\s*100|global plus)(?:\s|$|[(-])/.test(service)) return serviceIds[1];
    if (/^(global\s*200|super global)(?:\s|$|[(-])/.test(service)) return serviceIds[2];
    return !service||/^(north american\+|north american plus|global\s*50)(?:\s|$|[(-])/.test(service)?serviceIds[0]:null;
  };
  const linked=(child,parent)=>child.parent_relationship?.parent_key===parent.key||
    (parent.properties?._t2m_radio_pair&&child.properties?._t2m_radio_pair===parent.properties._t2m_radio_pair&&Number(child.properties?._t2m_radio_parent)===parent.variant_id);
  async function request(path,body) {
    const response=await fetch(route(path),{method:body?'POST':'GET',headers:{'Content-Type':'application/json',Accept:'application/json'},...(body?{body:JSON.stringify(body)}:{})});
    const result=await response.json();
    if (!response.ok||result.status) throw new Error(result.description||result.message||messages.request_failed);
    return result;
  }
  async function reconcile() {
    const cart=await request('cart.js');
    let changed=false;
    const seen=new Set();
    for (const child of cart.items.filter(item=>serviceIds.includes(item.variant_id))) {
      if (!child.properties?._t2m_radio_parent&&!child.parent_relationship) continue;
      const parent=cart.items.find(item=>linked(child,item));
      let quantity=parent?parent.quantity*(packUnits[parent.variant_id]||1):0;
      if (parent&&(serviceFor(parent)!==child.variant_id||seen.has(parent.key))) quantity=0;
      if (quantity>0) seen.add(parent.key);
      if (quantity!==child.quantity) {
        await request('cart/change.js',{id:child.key,quantity});
        changed=true;
      } else if (quantity>0&&(child.final_line_price!==0||child.requires_shipping||Number(child.selling_plan_allocation?.selling_plan?.id)!==planId)) {
        throw new Error(messages.review_required);
      }
    }
    return changed;
  }
  class SIMEnrollment extends HTMLElement {
    connectedCallback() {
      messages=JSON.parse(this.querySelector("[data-sim-errors]").textContent);
      this.addEventListener('click',this.handleClick);
      document.addEventListener('submit',this.beforeCheckout,true);
      this.observer=new MutationObserver(()=>this.syncQuantities());
      this.observer.observe(this,{subtree:true,childList:true,attributes:true,attributeFilter:['data-quantity','data-enrolled-quantity']});
      this.syncQuantities();
    }
    disconnectedCallback() {
      this.removeEventListener('click',this.handleClick);
      document.removeEventListener('submit',this.beforeCheckout,true);
      this.observer?.disconnect();
    }
    setBusy(value) {
      pending=value;
      document.querySelectorAll('t2m-sim-enrollment button, button[name="checkout"]').forEach(button=>{
        if(value){button.dataset.simWasDisabled=String(button.disabled);button.disabled=true;}
        else if(button.dataset.simWasDisabled!==undefined){button.disabled=button.dataset.simWasDisabled==='true';delete button.dataset.simWasDisabled;}
      });
      document.querySelectorAll('.additional-checkout-buttons').forEach(element=>{element.inert=value;});
    }
    showError(message) {
      const output=this.querySelector('[data-sim-message]');
      output.textContent=message;
      output.hidden=false;
    }
    beforeCheckout=async event=>{
      if(event.submitter?.name!=='checkout'||checkoutReady)return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if(pending)return;
      this.setBusy(true);
      try{
        if(await reconcile()){window.location.assign(route('cart'));return;}
        this.setBusy(false);
        checkoutReady=true;
        event.target.requestSubmit(event.submitter);
        checkoutReady=false;
      }catch(error){this.showError(error.message);this.setBusy(false);}
    };
    async syncQuantities() {
      const mismatch=this.querySelector('[data-sim-orphan]')||[...this.querySelectorAll('[data-sim-radio]')].some(row=>row.dataset.enrolled==='true'&&row.dataset.quantity!==row.dataset.enrolledQuantity);
      if(!mismatch||pending||this.syncFailed)return;
      this.setBusy(true);
      try{
        if(await reconcile())window.location.assign(route('cart'));
        else this.setBusy(false);
      }catch(error){this.syncFailed=true;this.showError(error.message);this.setBusy(false);}
    }
    handleClick=async event=>{
      const button=event.target.closest('[data-enroll-sim], [data-remove-sim]');
      if(!button||pending)return;
      const row=button.closest('[data-sim-radio]');
      const variantId=Number(row.dataset.variant);
      if(!serviceIds.includes(variantId))return;
      this.setBusy(true);
      try{
        const before=await request('cart.js');
        let parent=before.items.find(item=>item.key===row.dataset.parentKey);
        if(!parent)throw new Error(messages.cart_changed);
        const existing=before.items.filter(item=>serviceIds.includes(item.variant_id)&&linked(item,parent));
        for(const child of existing)await request('cart/change.js',{id:child.key,quantity:0});
        if(button.hasAttribute('data-enroll-sim')){
          if(serviceFor(parent)!==variantId)throw new Error(messages.service_changed);
          const quantity=parent.quantity*(packUnits[parent.variant_id]||1);
          if(quantity!==Number(row.dataset.quantity))throw new Error(messages.quantity_changed);
          const pair=parent.properties?._t2m_radio_pair||crypto.randomUUID();
          if(!parent.properties?._t2m_radio_pair){
            await request('cart/change.js',{id:parent.key,quantity:parent.quantity,properties:{...parent.properties,_t2m_radio_pair:pair}});
            parent=(await request('cart.js')).items.find(item=>item.properties?._t2m_radio_pair===pair);
            if(!parent)throw new Error(messages.match_failed);
          }
          await request('cart/add.js',{items:[{id:variantId,quantity,selling_plan:planId,properties:{'Renewal terms':row.dataset.terms,Radio:row.dataset.parentTitle,_t2m_included_year:'1',_t2m_radio_pair:pair,_t2m_radio_parent:String(parent.variant_id)}}]});
          const after=await request('cart.js');
          const children=after.items.filter(item=>item.variant_id===variantId&&linked(item,parent));
          const child=children[0];
          if(children.length!==1||child.final_line_price!==0||child.requires_shipping||Number(child.selling_plan_allocation?.selling_plan?.id)!==planId||child.quantity!==quantity){
            for(const line of children)await request('cart/change.js',{id:line.key,quantity:0});
            throw new Error(messages.enrollment_failed);
          }
        }
        window.location.assign(route('cart'));
      }catch(error){this.showError(error.message);this.setBusy(false);}
    };
  }
  customElements.define('t2m-sim-enrollment',SIMEnrollment);
})();
